import { render, staticRenderFns } from "./TableColumnHeaders.vue?vue&type=template&id=9bb3dfd0"
import script from "./TableColumnHeaders.vue?vue&type=script&lang=js"
export * from "./TableColumnHeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports